<!--
* @Name：供应商付款申请页面
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="供应商付款审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="paymentSituation" border>
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款情况</span>
        </template>
        <payment-situation :payment-data="paymentData" />
      </van-collapse-item>
      <van-collapse-item name="paymentDetails" border>
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款信息</span>
        </template>
        <payment-details
          :payment-type-code="paymentData.paymentTypeCode"
          :payment-details="paymentDetails"
          :order-info-list="orderInfoList"
        />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getPayOrderByCode } from '@/api/paymentRequest'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PayApproval',
  components: {
    'payment-situation': () => import('./components/PaymentSituation.vue'),
    'payment-details': () => import('./components/PaymentDetails.vue')
  },
  data() {
    return {
      activeNames: ['paymentSituation', 'approvalOpinions'],
      // id: this.$store.getters.businessKey,
      id: this.$route.query.businessKey,
      paymentData: {},
      paymentDetails: [],
      orderInfoList: [],
      attachList: []
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const response = await getPayOrderByCode(this.id)
      this.paymentData = response.data
      this.attachList = this.paymentData.files
      this.paymentDetails = response.data.payApplyDetailDtos
      this.orderInfoList = response.data.payApplyCollectionDtos
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
